import React, { ReactElement } from 'react';

import { getFacebookLink, getTwitterLink } from '../../utils/share';
import { ICON_FACEBOOK, ICON_TWITTER } from '../../icons';

import './Social.scss';

export function Social(): ReactElement {
  return (
    <div className="social">
      <a
        className="social__link"
        href={getFacebookLink()}
        target="_blank"
        rel="noopener noreferrer"
      >
        {ICON_FACEBOOK}
      </a>
      <a
        className="social__link"
        href={getTwitterLink()}
        target="_blank"
        rel="noopener noreferrer"
      >
        {ICON_TWITTER}
      </a>
    </div>
  );
}
